export default "__VITE_ASSET__CjuGLeEH__"